export default function passwordFormDirective() {
  return {
    template: require('./password.html'),
    scope: {},
    controller: 'PasswordFormController',
    controllerAs: 'passwordVM',
    bindToController: true,
    replace: true,
  };
}
